import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { MailCheck, MailWarning, Copy, Check } from "lucide-react";

export const InviteResultDialog = ({ result, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!result) return null;
  const link = result.invite_link || result.reset_link;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); } catch (e) { /* clipboard blocked */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="invite-result-dialog" className="rounded-2xl sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight flex items-center gap-2">
            {result.email_sent ? <MailCheck size={18} className="text-[#34C759]" /> : <MailWarning size={18} className="text-[#FF9500]" />}
            {result.email_sent ? "E-posta gönderildi" : "E-posta gönderilemedi"}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          {result.email_sent
            ? `${result.email} adresine güvenli bağlantı iletildi.`
            : `${result.email_error ? result.email_error + ". " : ""}E-posta yapılandırmasını kontrol edip yeniden gönderin.`}
        </p>
        {link && <div className="flex items-center gap-2 mt-1">
          <input readOnly data-testid="invite-link-input" value={link} onFocus={(e) => e.target.select()}
            className="flex-1 h-10 px-3 rounded-xl bg-slate-100/80 dark:bg-white/10 border border-slate-200/60 dark:border-white/10 text-xs dark:text-white focus:outline-none" />
          <button data-testid="invite-link-copy-button" onClick={copy}
            className="h-10 px-3.5 rounded-xl bg-[#0066CC] hover:bg-[#0052A3] text-white text-sm font-semibold flex items-center gap-1.5 transition-all">
            {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Kopyalandı" : "Kopyala"}
          </button>
        </div>}
      </DialogContent>
    </Dialog>
  );
};

export default InviteResultDialog;
